import { useCallback } from 'react';
import { useMutation, useQueryClient } from 'react-query';
// import WorkingHours from 'model/workingHours';
// import { Brand } from 'model/brand';

import {
  updateWorkingHours as updateWorkingHoursReq,
  Variables,
  ResponseStatus,
} from 'data/requests/updateWorkingHours';
import { CDError } from 'utils/error';

const useWorkingHoursActions = () => {
  const queryCache = useQueryClient();
  const { mutateAsync: updateWorkingHoursMutation, isLoading: updateLoading } =
    useMutation<ResponseStatus, CDError, Variables>(updateWorkingHoursReq);

  const updateWorkingHours = useCallback(
    async ({ brandId, hoursSettings, applyToAll }: Variables) => {
      const response = await updateWorkingHoursMutation({
        brandId,
        hoursSettings,
        applyToAll,
      });

      if (applyToAll) {
        queryCache.invalidateQueries(['working-hours']);
      } else {
        queryCache.invalidateQueries(['working-hours', brandId]);
      }
      queryCache.invalidateQueries(['brands']);

      // const workingHoursQuery = ['working-hours', brandId];
      // const cachedWorkingHours =
      //   queryCache.getQueryData<WorkingHours>(workingHoursQuery);
      // const updatedWorkingHours = {
      //   ...cachedWorkingHours,
      //   hoursSettings,
      // };
      // queryCache.setQueryData(workingHoursQuery, updatedWorkingHours);

      // const brandsQuery = 'brands';
      // const cachedBrands = queryCache.getQueryData<Brand[]>(brandsQuery) || [];
      // const brandsUpdated = cachedBrands.map((cachedBrand) => ({
      //   ...cachedBrand,
      //   timings:
      //     cachedBrand.id === brandId ? hoursSettings : cachedBrand.timings,
      // }));

      // queryCache.setQueryData(brandsQuery, brandsUpdated);

      return response;
    },
    [updateWorkingHoursMutation, queryCache],
  );

  return {
    isLoading: updateLoading,
    updateWorkingHours,
  };
};

export default useWorkingHoursActions;
